<template>
    <div class="navigation">
        <div v-bind="{[item.role]:true}" class="item" v-for="item in items" :class="{active: item.children.find(child=>$route.path.indexOf(child.route) === 0)}" @click="open(item)">
            <span class="itemtext">{{item.name}}</span>
            <div class="children" :class="{open: item.open}">
                <div v-bind="{[child.role]:true}" class="child" v-for="child in item.children" :class="{active: $route.path.indexOf(child.route) === 0}" @click="$router.push(child.route)">
                    {{child.name}}
                    <br />
                </div>
            </div>
            <hr>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        open(item){
            this.items.forEach(item=>{item.open = false});
            item.open = true;
        }
    },
    components: {
        
    },
    created(){
        this.items.forEach(item=>{
            this.$set(item, 'open', !!item.children.find(child=>this.$route.path.indexOf(child.route) === 0));
        });
    },
    props: [
        'items'
    ],
    data: function(){
        return {
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    .item, .child {
        color: $accromablue;
        &.active {
            color: #666666;
        }
        .itemtext {
            font-size: 1.5rem;
        }
        &:hover {
            color: $accromagrey;
        }
    }
    .children {
        padding-left: 10px;
        max-height: 0px;
        transition: max-height 0s;
        overflow: hidden;
        font-size: 1.25rem;
        &.open {
            max-height: 500px;
            transition: max-height 1s;
        }
    }
    .navigation {
        user-select: none;
        background-color: $accromabluehue;
        padding: 4px;
        height: 100%;
        padding-top: 10px;
    }
</style>
